import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

export function setVehiclePermissions(user: User, builder: AbilityBuilder<AppAbility>) {
  const { can } = builder;
  const canManageVehicle =
    user.roles.includes(SubjectRoles.MasterdataAdministrator) || user.roles.includes(SubjectRoles.FitIntModerator);

  if (canManageVehicle) {
    can(Action.Manage, "Vehicle");
  } else if (user.roles.includes(SubjectRoles.Int)) {
    can(Action.Read, "Vehicle");
  }

  if (user.roles.includes(SubjectRoles.MasterdataAdministrator)) {
    can(Action.Manage, "VehicleStatus");
  }
}
